import React from "react";
import SaleLabel from "./SaleLabel";
import "./Tile.scss";

export default function Tile(props) {
  const { url, top_sales_photo_url, tagline } = props.details;

  return (
    <div className="top-sales-tile">
      <a href={url}>
        <img
          src={top_sales_photo_url}
          className="top-sales-photo"
          alt={tagline}
        />
        <SaleLabel details={props.details} />
      </a>
    </div>
  );
}
